import React, { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Layout, Menu, Typography } from "antd";
import {
  UsergroupAddOutlined,
  ShopOutlined,
  ProductOutlined,
  HomeOutlined,
  AreaChartOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { IonIcon } from "@ionic/react";
import {
  personAddOutline,
  giftOutline,
  imageOutline,
  pricetagsOutline,
  radioOutline,
  walletOutline,
} from "ionicons/icons";
import metaData from "../../data/metaData";
import log from "../../utils/log";
import useAuthStore from "../../states/useAuth";

const { Sider } = Layout;

const SiderComponent = ({ collapsed, onCollapse }) => {
  const history = useHistory();
  const location = useLocation();

  const { auth, user } = useAuthStore();

  const items = [
    {
      key: "/merchantUser/home",
      label: "Home",
      icon: <HomeOutlined />,
      isShow: true,
    },
    {
      key: "/merchantUser/shop",
      label: "Shop",
      icon: <ShopOutlined />,
      isShow: user?.permission?.shop,
    },
    {
      key: "/merchantUser/product",
      label: "Product",
      icon: <ProductOutlined />,
      isShow: user?.permission?.product?.issue,
    },
    {
      key: "/merchantUser/user",
      label: "User & Permission",
      icon: <UsergroupAddOutlined />,
      isShow: user?.permission?.staff,
    },
    {
      key: "/merchantUser/coin",
      label: "Coin",
      icon: <IonIcon icon={walletOutline} />,
      isShow: user?.permission?.estamp?.issue,
    },
    {
      key: "/merchantUser/report/distribute",
      label: "Report",
      icon: <AreaChartOutlined />,
      isShow: user?.permission?.report?.length > 0,
    },
    {
      key: "/merchantUser/setting",
      label: "Setting",
      icon: <SettingOutlined />,
      isShow: true,
    },
    {
      key: "promotion",
      label: "Promotion",
      type: "group",
      children: [
        {
          key: "/merchantUser/promotionCode",
          label: "Promotion Code",
          icon: <IonIcon icon={pricetagsOutline} />,
          isShow: user?.permission?.promotionCode,
        },
        {
          key: "/merchantUser/welcome",
          label: "Welcome",
          icon: <IonIcon icon={giftOutline} />,
          isShow: user?.permission?.welcome,
        },
        {
          key: "/merchantUser/referral",
          label: "Referral",
          icon: <IonIcon icon={personAddOutline} />,
          isShow: user?.permission?.welcome,
        },
        {
          key: "/merchantUser/ad",
          label: "Ad",
          icon: <IonIcon icon={imageOutline} />,
          children: [
            {
              key: "/merchantUser/ad/banner",
              label: "Banner",
              icon: <IonIcon icon={imageOutline} />,
            },
          ],
          isShow: user?.permission?.ad,
        },
        {
          key: "/merchantUser/pushNotification",
          label: "Push Notification",
          icon: <IonIcon icon={radioOutline} />,
          isShow: user?.permission?.pushNotification,
        },
      ],
      isShow:
        user?.permission?.promotionCode ||
        user?.permission?.welcome ||
        user?.permission?.ad ||
        user?.permission?.pushNotification,
    },
  ].filter((item) => item.isShow);

  // Helper function to find the active key recursively
  const findActiveKey = (items, pathname) => {
    for (const item of items) {
      if (item.key === pathname) {
        return { activeKey: item.key, openKey: null };
      }
      if (item.children) {
        const result = findActiveKey(item.children, pathname);
        if (result) {
          return { activeKey: result.activeKey, openKey: item.key };
        }
      }
    }
    return null;
  };

  // Calculate active key and open key
  const { activeKey, openKey } = useMemo(() => {
    const { pathname } = location;
    return findActiveKey(items, pathname) || { activeKey: null, openKey: null };
  }, [location.pathname, items]);

  const onClickMenuItem = (e) => {
    history.push(e.key);
  };

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      theme="light"
      style={{
        overflow: "auto",
        height: "100vh",
        position: "fixed",
        insetInlineStart: 0,
        top: 0,
        bottom: 0,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "16px",
          fontWeight: "bold",
          fontSize: "1.25rem",
          borderRight: "1px solid var(--ion-color-step-100)",
        }}
      >
        <img
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "5px",
          }}
          src={metaData.blobPreURL + metaData.appLogoPath + metaData.blobPostURL}
          alt="Logo"
        />
        <span
          onClick={() => {
            log.debug(auth);
          }}
        >
          Pearl
        </span>
      </div>
      <Menu
        mode="inline"
        onClick={onClickMenuItem}
        items={items}
        defaultSelectedKeys={[activeKey]}
        defaultOpenKeys={[openKey]}
        selectedKeys={[activeKey]}
        style={{ height: "calc(100% - 82px)" }}
      />
    </Sider>
  );
};

export default SiderComponent;
